import SubscribeForm from '@frontend/features/fluent-form/subscribe-form/SubscribeForm'
import MenuList from '@frontend/features/navigation/components/menu/MenuList'
import useSiteConfiguration from '@frontend/libs/hooks/useSiteConfiguration'
import { __ } from '@wordpress/i18n'

import BackToTopButton from './BackToTopButton'

function DesktopFooter() {
  const currentYear = new Date().getFullYear()
  const { menus } = useSiteConfiguration()

  return (
    <>
      <footer className="bg-[#f7f8fa]">
        <div className="container mx-auto max-w-screen-2xl py-14 md:py-28">
          <div className="grid grid-cols-1 gap-6 md:grid-cols-4">
            {menus?.footer?.map((menu) => (
              <div key={menu.title}>
                <MenuList items={menu.items} title={menu.title} />
              </div>
            ))}
            <div>
              <SubscribeForm />
            </div>
          </div>
        </div>
        <div className="container mx-auto max-w-screen-2xl py-6">
          <span className="text-sm">
            {' '}
            {__(`© ${currentYear} ASAVAGROUP CORPORATION`, 'asavagroup')}
          </span>
        </div>
      </footer>
      <BackToTopButton />
    </>
  )
}

export default DesktopFooter
